module.exports = "<div class=\"next-button\">\n  Next\n  <i class=\"icon icon-icon-arrow-fwd\"></i>\n</div>\n"